import { Box, Grid } from '@mui/material';
import { HistoryFilter } from 'components/History';
import React from 'react';
import { InfoCard, SparkDateRangePicker } from 'sharedComponents/UI';
import moment from 'moment';
import MemoryChatListItem from './MemoryChatListItem';
import { useMemoryChatSearch } from 'hooks/memory';
import MemoryQACardSkeleton from 'sharedComponents/Skeleton/MemoryQACardSkeleton';

type MemoryEditHistoryProps = {
  memoryID: string;
  onMemoryChatClick: (memoryChatID: string) => void;
  activeMemoryChatID: string;
};
function MemoryEditHistory({
  memoryID,
  onMemoryChatClick,
  activeMemoryChatID,
}: MemoryEditHistoryProps) {
  const [historyFilter, setHistoryFilter] = React.useState<HistoryFilter>({
    dateRange: {
      startDate: moment().subtract(1, 'month'),
      endDate: moment(),
    },
  });
  const { memoryChats, chatByMemoryChatID, isLoading } = useMemoryChatSearch({
    memoryID,
    historyDateRangeFilter: historyFilter.dateRange,
  });

  if (isLoading) {
    return <MemoryQACardSkeleton />;
  }

  const getChatByMemoryChatID = (memoryChatID: string) => {
    return chatByMemoryChatID?.[memoryChatID]?.id || '';
  };
  return (
    <Grid container gap={2} pb={2}>
      <SparkDateRangePicker
        historyFilter={historyFilter}
        setHistoryFilter={setHistoryFilter}
      />
      {!memoryChats?.length ? (
        <Box width='100%'>
          <InfoCard info='No results found' type='info' />
        </Box>
      ) : (
        <>
          {memoryChats?.map((memoryChat) => (
            <MemoryChatListItem
              key={memoryChat.id}
              memoryChat={memoryChat}
              onMemoryChatClick={() =>
                onMemoryChatClick(getChatByMemoryChatID(memoryChat.id))
              }
              chat={chatByMemoryChatID?.[memoryChat.id]}
              isSelected={
                activeMemoryChatID === getChatByMemoryChatID(memoryChat.id)
              }
            />
          ))}
        </>
      )}
    </Grid>
  );
}

export default MemoryEditHistory;
